import React, {Component} from "react";
import {Form, Input, Button, message, Popover} from "antd";
import "./Login.less";
import http from '@/http';
import {API} from '@/http/api';
import Logo from "@/images/logo-60.png";

class LoginForm extends React.Component {
    state = {
        captchaImage: '',
        uuid: '',
        loading: false,
    };
    goLink = (item) => {
        window.open(item.link)
    }

    componentDidMount() {
        this.getCaptchaImage();
    }

    // 获取验证码
    getCaptchaImage = (result, phone) => {
        const config = {
            api: API.userCaptchaImage,
            data: {},
        }
        http(config).then((res) => {
            if (res.code === 200) {
                const captchaEnabled = res.result.captchaEnabled
                if (captchaEnabled) {
                    this.setState({
                        captchaImage: "data:image/gif;base64," + res.result.img,
                        uuid: res.result.uuid
                    });
                }
            }
        })
    }
    handleSubmitLogin = e => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                this.setState({loading: true});
                const config = {
                    api: API.userLogin,
                    data: {
                        mobile: values.mobile,
                        password: values.password,
                        code: values.code,
                        uuid: this.state.uuid,
                    },
                }
                http(config).then((res) => {
                    if (res.code == 200) {
                        this.setState({loading: false});
                        message.success('登录成功');
                        const config = {
                            api: API.usergetLoginInfo,
                        };
                        http(config).then((res) => {
                            if (res.success) {
                                localStorage.setItem('userform', JSON.stringify(res.result))
                                if (res.result.crmFlag == 0) {
                                    localStorage.setItem('identity', 0)
                                } else {
                                    localStorage.setItem('identity', 1)
                                }
                                window.location.href = '/';
                            }
                        })
                    } else {
                        this.getCaptchaImage();
                        this.setState({loading: false});
                    }
                })
            }
        })
    }

    render() {
        const {getFieldDecorator} = this.props.form;
        return (
            <div className="login-form-box forsd">
                <div className="login_content">
                    <Form onSubmit={this.handleSubmitLogin} className="login-form">
                        <Form.Item label="">
                            {getFieldDecorator("mobile", {
                                rules: [
                                    {required: true, message: "请输入您的账号/手机号码"},
                                    {pattern: /^1[0-9]{10}$/, message: "请输入正确的手机号码"}
                                ]
                            })(
                                <Input
                                    autoComplete="off"
                                    className="login-input"
                                    placeholder="请输入您的账号/手机号码"
                                    // onBlur={this.checkAccount}
                                />
                            )}
                        </Form.Item>
                        <Form.Item label="" className="code_item">
                            {getFieldDecorator("password", {
                                rules: [{required: true, message: "请输入您的密码"}]
                            })(
                                <Input.Password
                                    autoComplete="off"
                                    className="login-input"
                                    placeholder="请输入您的密码"
                                />
                            )}
                        </Form.Item>
                        <Form.Item label="">
                            {getFieldDecorator("code", {
                                rules: [{required: true, message: "请输入验证码"}]
                            })(
                                <Input
                                    autoComplete="off"
                                    className="code"
                                    placeholder="请输入验证码"
                                />
                            )}
                            <img onClick={this.getCaptchaImage} className="captchaImage" src={this.state.captchaImage}
                                 alt="captcha"/>
                        </Form.Item>
                        <Button style={{marginTop: '24px', height: '40px', fontSize: '16px'}} type="primary"
                                htmlType="submit" loading={this.state.loading} block>登录</Button>
                    </Form>
                </div>
            </div>
        );
    }
}

const WrappedLoginForm = Form.create({name: 'LoginForm'})(LoginForm);

class Login extends Component {

    render() {
        return (
            <div className='login'>
                <div className='top'>
                    <div className="logn-img">
                        {/*<img src='https://file.idf10.com/mp/logo_platform.png' alt="" />*/}
                        <img src={Logo} width={50} height={50} alt=""/>
                        <span className='slogan'>轨迹查询</span>
                    </div>
                </div>
                <div className='middle'>
                    <div>
                        <div className='title'>
                            <div className='title-top'>欢迎来到数十方!</div>
                        </div>
                        <div className='form'>
                            <div className='form-title'>账号密码登录</div>
                            <WrappedLoginForm {...this.props}></WrappedLoginForm>
                        </div>
                    </div>
                </div>
                <div className='botm'>
                    <span>©2021数通十方（深圳）数字科技有限公司版权所有&nbsp;&nbsp;|&nbsp;&nbsp;ICP许可证编号：粤B2-20211243&nbsp;&nbsp;|&nbsp;&nbsp;ICP备案号：粤ICP备2021060024号&nbsp;&nbsp;|&nbsp;&nbsp;公安备案号：44030502007406&nbsp;&nbsp;|&nbsp;&nbsp;营业执照</span>
                </div>
            </div>
        );
    }
}

export default Login;